import { LockKeyhole, Mail } from "lucide-react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { ClubLogo } from "../components/ClubLogo";
import { useAuth } from "../context/AuthContext";
import api, { apiError } from "../lib/api";
import "./AuthPageV2.css";
import "./AuthCenteredLogo.css";
import "./AuthLinks.css";

const HERO_IMAGE = "https://static.prod-images.emergentagent.com/jobs/d11551e1-9395-4cdc-ac43-9b307cfb1bc4/images/2e2a242e527b681c766afdf049b09733b26ab14ab902191b2bbe560b667d91a9.jpeg";

export default function AuthPageV2() {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(`/auth/${mode === "login" ? "login" : "register"}`, { email, password });
      signIn(data);
      toast.success(mode === "login" ? "Bem-vindo de volta!" : "Conta criada com sucesso!");
      navigate(data.user.profile_completed ? "/" : "/completar-perfil");
    } catch (error) {
      toast.error(apiError(error));
    } finally {
      setBusy(false);
    }
  };
  return <main className="editorial-auth" style={{ backgroundImage: `url(${HERO_IMAGE})` }} data-testid="auth-page"><div className="editorial-auth-top"><ClubLogo size="small" /><span>PELADA DOS PERNINHAS</span></div><section className="editorial-auth-panel"><p className="editorial-slogan">organização de jogos<br />e a resenha de sempre.</p><form onSubmit={submit} className="editorial-auth-form" data-testid="auth-form"><label><Mail size={17} /><input value={email} onChange={(event) => setEmail(event.target.value)} type="email" placeholder="Seu e-mail" required data-testid="auth-email-input" /></label><label><LockKeyhole size={17} /><input value={password} onChange={(event) => setPassword(event.target.value)} type="password" minLength="6" placeholder="Sua senha" required data-testid="auth-password-input" /></label><button disabled={busy} data-testid="auth-submit-button">{busy ? "Aguarde..." : mode === "login" ? "Entrar na pelada" : "Criar minha conta"}<span>→</span></button></form><div className="editorial-auth-links"><Link to="/esqueci-senha" data-testid="forgot-password-link">Esqueceu sua senha?</Link><button onClick={() => setMode(mode === "login" ? "register" : "login")} data-testid="auth-mode-toggle">{mode === "login" ? "Cadastre-se" : "Já tenho uma conta"}</button></div></section></main>;
}